"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.setConfig = void 0;
const config = {
    multiLanguageSubUrl: {},
    country: '',
    serverDatetime: new Date().toISOString(),
    useMockApi: '',
    interwovenServer: '',
    bannerMultiLanguageSubUrl: {},
    loginMultiLanguageSubUrl: {},
    footerMultiLanguageSubUrl: {},
    publicPath: '',
    msUiTokenManagement: '',
};
const setConfig = (_config) => Object.assign(config, _config);
exports.setConfig = setConfig;
const getConfig = () => config;
exports.getConfig = getConfig;
